module.exports = __webpack_public_path__ + "img/dropdown_arrow.f45baf8d.svg";